import { AxiosRequestConfig } from "axios";
import { requester } from "../config";



export const fetchHomePage = (data = {}, config: AxiosRequestConfig = {}) =>
  requester.post("/user_home", { ...data, mode: "web_app" }, config);

export const fetchUserPage = (page: string, config: AxiosRequestConfig = {}) =>
  requester.post(`/user_${page}`, {}, config);

export const fetchPage = (pageid: string, pagedata = {}, config: AxiosRequestConfig = {}) => {
  return requester.post('/user_pages', { pageid, pagedata }, config);
};

export const fetchForm = (
  { formid, publicForm = false }: { formid: string; publicForm?: boolean },
  config: AxiosRequestConfig = {},
) => requester.post(`/user_forms${publicForm ? "_public" : ""}`, { formid }, config);
